<!-- 页面弹框。如弹出车辆轨迹、作业记录等 -->
<template>
  <div class="page-dialog_panel" :class="{ hide: !show, [skin]: skin }">
    <transition name="el-fade-in">
      <div v-show="show" class="page-dialog_panel-main">
        <div class="dialog-title">
          <div class="close" @click="close">
            <img src="./close.png" alt="关闭" />
          </div>
          <slot name="head" />
        </div>
        <div class="dialog-body">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    /** 是否显示 */
    show: {
      type: Boolean,
      default: false,
    },
    skin: {
      type: String,
      default: "green", // green,blue
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.page-dialog_panel {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1999; // 2000 以后是错误消息的空间
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  /** 隐藏 */
  &.hide {
    width: 0;
    height: 0;
  }
  &.blue {
    .page-dialog_panel-main {
      .dialog-title {
        background-color: #0061a6;
      }
      .dialog-body {
        border-color: #00477a;
        .date-picker {
          background: #00223b;
          border-color: #005999;
          color: #00528c;
          .el-range-separator {
            color: #00528c;
          }
          .el-range-input {
            &::placeholder {
              color: #00528c;
            }
          }
        }
        .search-button {
          background: #005999;
        }
      }
    }
  }
  /** 内容区域样式 */
  .page-dialog_panel-main {
    width: 1351px;
    height: 777px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0px 8px 0px #0000004d;
    overflow: hidden;
    background-color: #000;
    display: flex;
    flex-direction: column;
    .dialog-title {
      background-color: #00a756;
      color: #fff;
      height: 36px;
      line-height: 16px;
      padding: 10px 12px;
      font-size: 16px;
      .close {
        float: right;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 1;
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
    .dialog-body {
      border: 8px solid #007a3f;
      flex: 1;
    }
    .page_panel {
      height: 100%;
      /** 车辆轨迹地图 */
      // #vehicleTrackMap,
      // #jobTrajectoryMap { /** 作业记录地图 */
      //     height: calc(100% - 45px);
      // }
      /** 按钮 */
      .zoom-tool {
        bottom: 80px;
      }
    }
  }
  .layer-tool {
    position: absolute;
    left: 24px;
    bottom: 80px;
    z-index: 999;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px #999999;
    border-radius: 4px;
    overflow: hidden;
    .item {
      width: 44px;
      height: 58px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #5473e8;
    }
    .active {
      background-color: rgba(222, 229, 255, 1);
    }
  }
}
</style>
